<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop: true }"></ngx-loading>
<div class="edit-container position-absolute z-index-3 white-background row w-100">
  <div class="re-links-container">
    <button class="btn em-btn teal-background" (click)="cancelUpdate()">
      <i class="far fa-times" aria-hidden="true"></i>
    </button>
  </div>

  <div class="toolbar row px-2 navy-background mx-auto w-100">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <h5 class="white-font text-uppercase m-0 mr-2">
        <span *ngIf="setting?.communicationSettingType === CommunicationSettingType.ScheduledConfirmation"
          >Edit Scheduled Confirmation Email</span
        >
        <span *ngIf="setting?.communicationSettingType === CommunicationSettingType.ChangedConfirmation"
          >Edit Changed Confirmation Email</span
        >
        <span *ngIf="setting?.communicationSettingType === CommunicationSettingType.CancelledConfirmation"
          >Edit Cancelled Confirmation Email</span
        >
        <span *ngIf="setting?.communicationSettingType === CommunicationSettingType.VisitReminder"
          >Edit Visit Reminder Email</span
        >
        <span *ngIf="setting?.communicationSettingType === CommunicationSettingType.FormsReminder"
          >Edit Forms Reminder Email</span
        >
        <span *ngIf="setting?.communicationSettingType === CommunicationSettingType.CreditCardReminder"
          >Edit Credit Card Reminder Email</span
        >
        <span *ngIf="setting?.communicationSettingType === CommunicationSettingType.GiftCardPurchase"
          >Edit Gift Card Purchase Email</span
        >
      </h5>
      <div class="d-flex flex-nowrap mr-3">
        <button
          class="btn em-btn em-btn-green mr-4 campaign-button"
          (click)="saveChanges()"
          [disabled]="!reminderSettingsForm.valid"
        >
          SAVE
        </button>
        <button class="btn em-btn em-btn-green mr-4" (click)="sendTest()">Send Test</button>
        <button class="btn em-btn em-btn-green mr-4 campaign-button" (click)="cancelUpdate()">Cancel</button>
      </div>
    </div>
  </div>

  <div *ngIf="showSuccessMessage" class="success-banner">Saved successfully!</div>

  <div class="d-flex w-100" style="height: calc(100% - 80px)">
    <form [formGroup]="reminderSettingsForm" class="line-height-1 px-0 light-grey-background col-4 h-100 overflow-auto">
      <div class="row mx-0 teal-background">
        <div class="col">
          <h6 class="white-font uppercase my-0 py-2">Email Settings</h6>
        </div>
      </div>

      <div class="py-3">
        <div class="row mx-0">
          <div class="col">
            <mat-form-field class="w-75">
              <mat-label>Original Email Template</mat-label>
              <mat-select formControlName="template">
                <mat-option *ngFor="let template of emailTemplates" [value]="template">
                  {{ template.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <button
              class="btn btn-sm em-btn em-btn-green py-2 mx-2 font-weight-bold mb-3"
              style="line-height: 1em"
              tooltipclass="em-tooltip"
              title="Revert back to original email template."
              (click)="revertToOriginalTemplate()"
              [disabled]="!reminderSettingsForm.get('template').value"
            >
              <i class="fas fa-undo pr-2"></i>Revert
            </button>
          </div>
        </div>
        <div class="row mx-0">
          <div class="col">
            <mat-form-field class="w-100">
              <input matInput placeholder="Sender Name" formControlName="emailSenderName" />
            </mat-form-field>
          </div>
        </div>
        <div class="row mx-0">
          <div class="col">
            <mat-form-field class="w-100">
              <input matInput placeholder="Sender Email Address" formControlName="emailSenderEmail" />
            </mat-form-field>
          </div>
        </div>
        <div class="row mx-0">
          <div class="col">
            <mat-form-field class="w-100">
              <input formControlName="emailSubjectLine" matInput placeholder="Email Subject" />
            </mat-form-field>
          </div>
        </div>
        <div class="row mx-0 mb-3">
          <div class="col mx-0">
            <div class="text-dark">
              <ng-template #emojiTemplate>
                Include emojis 😍💖😊 in your email subject line!
                <ul class="mb-0">
                  <li>On Mac: Press Control+Command+Space while editing the text</li>
                  <li>On Windows: Press Windows+. while editing the text</li>
                </ul>
              </ng-template>
              <div kendoTooltip [tooltipTemplate]="emojiTemplate" filter="i" position="right">
                Use Emoji <i class="fa fa-question-circle teal-font"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mx-0 teal-background">
        <div class="col">
          <h6 class="white-font uppercase mb-0 py-2">Available fields</h6>
        </div>
      </div>

      <div class="py-3">
        <div class="row mx-0">
          <div class="col">
            <ul *ngIf="setting?.communicationSettingType === CommunicationSettingType.VisitReminder" class="mb-0">
              <li>FirstName</li>
              <li>PatientName</li>
              <li>VisitDate</li>
              <li>VisitTime</li>
              <li>ConfirmVisitEndpoint</li>
            </ul>
            <ul *ngIf="setting?.communicationSettingType === CommunicationSettingType.FormsReminder" class="mb-0">
              <li>FirstName</li>
              <li>PatientName</li>
              <li>ConfirmEmailEndpoint</li>
            </ul>
            <ul *ngIf="setting?.communicationSettingType === CommunicationSettingType.CreditCardReminder" class="mb-0">
              <li>FirstName</li>
              <li>PatientName</li>
              <li>RequestCreditCardEmailEndpoint</li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row mx-0 teal-background">
        <div class="col">
          <h6 class="white-font uppercase mb-0 py-2">When to send</h6>
        </div>
      </div>

      <div class="py-3">
        <div class="row mx-0">
          <div class="col-6 d-flex flex-column navy-font">
            <span *ngIf="setting?.communicationSettingType === CommunicationSettingType.VisitReminder">
              Send visit reminders between:
            </span>
            <span *ngIf="setting?.communicationSettingType === CommunicationSettingType.FormsReminder">
              Send form reminders between:
            </span>
            <span *ngIf="setting?.communicationSettingType === CommunicationSettingType.CreditCardReminder">
              Send credit card reminders between:
            </span>
            <div class="d-flex justify-content-between align-items-center mb-2 mt-2">
              <kendo-timepicker
                class="communication-timepicker"
                name="startTime"
                placeholder="Select"
                [steps]="{ minute: minimumDuration }"
                [(value)]="workerStartTime"
                (valueChange)="onStartTimeChange($event)"
              >
              </kendo-timepicker>
              <span class="mx-3">and</span>
              <kendo-timepicker
                class="communication-timepicker"
                name="endTime"
                placeholder="Select"
                [steps]="{ minute: minimumDuration }"
                [min]="minEndTime"
                [(value)]="workerEndTime"
              >
              </kendo-timepicker>
            </div>
          </div>
        </div>

        <div class="row mx-0">
          <div class="col navy-font d-flex align-items-center">
            Send
            <input type="number" class="input-number mx-2" formControlName="firstNotificationPeriod" min="1" />
            <mat-form-field class="sender-type ml-1 mr-2">
              <mat-select formControlName="firstNotificationUnit">
                <mat-option *ngFor="let type of senderUnits" [value]="type">
                  {{ type }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            before their visit
          </div>
        </div>

        <div class="row mx-0">
          <div class="col d-flex align-items-center navy-font">
            <mat-checkbox class="reports-checkbox mr-2" formControlName="enabledRepeatNotification"> </mat-checkbox>
            <div
              class="d-flex align-items-center"
              [ngClass]="{ 'disabled-element': !this.reminderSettingsForm.controls['enabledRepeatNotification'].value }"
            >
              Send every
              <input type="number" class="input-number mx-2" formControlName="repeatNotificationPeriod" min="1" />
              <mat-form-field class="sender-type ml-1 mr-2">
                <mat-select formControlName="repeatNotificationUnit">
                  <mat-option *ngFor="let type of senderUnits" [value]="type">
                    {{ type }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <span *ngIf="setting?.communicationSettingType === CommunicationSettingType.VisitReminder">
                until the visit has been confirmed
              </span>
              <span *ngIf="setting?.communicationSettingType === CommunicationSettingType.FormsReminder">
                until all forms have been completed
              </span>
              <span *ngIf="setting?.communicationSettingType === CommunicationSettingType.CreditCardReminder">
                until there is a credit card on file
              </span>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="px-3 mr-3 h-100 flex-grow-1">
      <div class="d-flex flex-column h-100">
        <div class="row mx-0 teal-background">
          <div class="col d-flex justify-content-between">
            <ng-template #editorHelpTemplate>
              For the best email editing experience use a desktop or laptop computer.
            </ng-template>
            <h6 class="white-font uppercase my-0 mr-auto py-2">Template Definition</h6>
            <h6
              *ngIf="iPad"
              kendoTooltip
              [tooltipTemplate]="editorHelpTemplate"
              position="left"
              filter="span"
              class="white-font uppercase my-0 py-2"
            >
              <span class="ml-auto pl-5"><i class="fa fa-question-circle"></i></span>
            </h6>
          </div>
        </div>

        <div class="w-100 flex-grow-1 d-flex align-items-start justify-content-center px-0 pb-2 light-grey-background">
          <div class="h-100 w-100" [hidden]="!reminderSettingsForm.get('template').value">
            <app-unlayer-email-editor
              id="unlayer"
              class="email-editor"
              [options]="editorOptions"
              (loaded)="onEditorLoad()"
              #editor
            ></app-unlayer-email-editor>
          </div>
          <div
            *ngIf="!reminderSettingsForm.get('template').value"
            class="w-100 h-100 d-flex align-items-center justify-content-center no-template light-grey-background"
          >
            Please select an email template to edit.
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
